
import React from 'react';

import Lottie from 'react-lottie';

type LottieAnimationProps = {
    animationData: object;
    height?: string;
    width?: string;
    minHeight?: string;
};

const LottieAnimation: React.FC<LottieAnimationProps> = ({ animationData, height, width, minHeight }) => {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: ''
        }
    };

    return (
        <Lottie options={defaultOptions} height={height} width={width} minHeight={minHeight} />
    );
};

export default LottieAnimation;
